/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import 'moment/locale/pt';
import FixedContainer from '../../components/Container';
import { Box, Button, CircularProgress, Typography, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { enqueueSnackbar } from 'notistack';
import CustomizedTables from '../../components/Table';
import { GetFetch, PostFetch, urls } from '../../services/apiBase';
import PaginationRounded from '../../components/NewPagination';

const Reports = () => {
  const [baseDate, setBaseDate] = useState(null);
  const [initialDate, setInitialDate] = useState(null);
  const [report, setReport] = useState();
  const [reportSelected, setReportSelected] = useState('cprs-ativa');
  const [createLoad, setCreateLoad] = useState(false);
  const [load, setLoad] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const limit = 25;

  const BASE_URL = `/financial/reports/`

  const creationSuccessOrError = (message, isSuccess) => {

    if (isSuccess) {
      enqueueSnackbar(message, { variant: 'success' });
    } else {
      enqueueSnackbar(message, { variant: 'error' });
    }
  }

  const getReports = async () => {
    setLoad(true)
    setCreateLoad(true)

    try {

      const data = await processReport()

      const { reports } = data
      
      setTotalPages(reports.lastPage)
      setReport(reports.data)
    } catch(error) {
      console.log(error)
    } finally {
      setLoad(false)
      setCreateLoad(false)

    }
  }

  const processReport = async (preWaiting) => {
    let result = true

    if (preWaiting) {
      await waitProcess(16000)
    }
    
    while(result) {
      console.log("CHECK processReport")
      const { data } = await GetFetch(`${BASE_URL}list`, {
        params: {
          reportProcess: true
        }
      })
      const { reports } = data

      if (reports.data.length === 0) {
        result = false
      } else {
        await waitProcess(16000)
      }
    }

    const { data } = await GetFetch(`${BASE_URL}list`, {
      params: {
        reportName: reportSelected,
        page: currentPage,
        limit: limit
      }
    })

    return data
  
}

  useEffect(() => {
    getReports()
  }, [reportSelected, currentPage])

  const REPORTS_LIST = [
    { name: 'CPRFs ativas', value: 'cprs-ativa' },
    { name: 'CPRFs pagas', value: 'cprs-pagas' },
    { name: 'CPRFs - Acumulado mensal', value: 'cprs-acumulado-mensalmente' },
    { name: 'CPRFs - Por quartil', value: 'cprs-quarter' },
    { name: 'CPRFs - B3', value: 'cprs-B3' }
  ]

  const COLUMNSTABLE = [
    {
      headerName: 'Relatório',
      type: 'default',
      value: {
        first: {
          value: 'name'
        }
      }
    },
    {
      headerName: 'Data base',
      type: 'date',
      value: {
        first: {
          value: 'base_date'
        }
      }
    },
    {
      headerName: 'Data da geração',
      type: 'date',
      value: {
        first: {
          value: 'generate_date'
        }
      }
    },
    
  ]

  const handleDownloadReport = async (row) => {
    try {
      const resolve = await GetFetch(`${BASE_URL}downloadReport`, {
        params: {
          reportId: row.id
        }
      })
      console.log(resolve.data)
      window.location.href = resolve.data
    } catch(error) {
      console.log(error)
    } 
  }

  const registerButtonComponent = (row) => {
    return (
      <Button 
        variant="contained" 
        color="success" 
        sx={{ marginRight: 1 }} 
        onClick={() => handleDownloadReport(row)}>Baixar</Button>
    )
  }

  function waitProcess(timeWait) {
    console.log('WAITING')
    return new Promise((resolve) => setTimeout(resolve, timeWait))
  }

  const handleCreate = async () => {
    setCreateLoad(true)
    try {
      if(reportSelected.includes(REPORTS_LIST[1].value)) {
        const resolve = await PostFetch(`${BASE_URL}create`, {
          reportName: reportSelected,
          baseDate: baseDate,
          initialDate: initialDate
        })
        const { report } = resolve.data;
        console.log(report)
  
        window.location.href = report;
  
      } else {
        PostFetch(`${BASE_URL}create`, {
          reportName: reportSelected,
          baseDate: baseDate
        })
                
        const data = await processReport(true) 
        const { reports } = data

        const [ first , ...rest] = reports.data
        console.log('RESULT', first.id)
        console.log ('first >>>>>>>', first)
        await handleDownloadReport(first);
      }
      await getReports();
      creationSuccessOrError(`Relatório criado com sucesso`, true);

    } catch(error) {
      console.log(error)
      creationSuccessOrError(`Erro ao gerar o relatório`, false);

    } finally {
      setCreateLoad(false)
    }

  }

  return (
    <FixedContainer>
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#F9FBFD',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 3,
        borderRadius: '10px',
        padding: 2,

      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
          Selecione um relatório
        </Typography>

        <Box sx={{
          flexDirection: 'row',
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}>
          <Box sx={{
             flexDirection: 'row',
             display: 'flex',
             justifyContent: 'flex-start',
             alignItems: 'center',
             width: '80%',

          }}>
            <Box sx={{
              width: '40%'
            }}>
              <FormControl 
                fullWidth
                disabled={createLoad}

                >
                <InputLabel id="reports-select">Selecione</InputLabel>
                <Select
                  labelId="reports-select"
                  id="reports-select-id"
                  label="Selecione o relatório"
                  value={reportSelected}
                  onChange={e => setReportSelected(e.target.value)}

                >
                  {
                    REPORTS_LIST.map((report, index) => (
                      <MenuItem key={index + 1} value={report.value}>{report.name}</MenuItem>

                    ))
                  }
                </Select>
              </ FormControl>
            </Box>

            {
              reportSelected === REPORTS_LIST[1].value &&
              <Box sx={{
                width: '40%',
                marginLeft: '8px'
              }}>
                <DatePicker
                  sx={{ margin: '10px 0', width: '100%' }}
                  label="Data inicial"
                  value={initialDate}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => setInitialDate(newValue)}
                  disabled={createLoad}
  
                />
              </Box>
            }
            <Box sx={{
              width: '40%',
              marginLeft: '8px'
            }}>
              <DatePicker
                sx={{ margin: '10px 0', width: '100%' }}
                label={reportSelected === REPORTS_LIST[1].value ? 'Data Final' : "Data base"}
                value={baseDate}
                format="DD/MM/YYYY"
                onChange={(newValue) => setBaseDate(newValue)}
                disabled={createLoad}

              />
            </Box>
          </Box>
          <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginLeft: '20px',
            width: '20%'
          }}>
          <Button
          sx={{minWidth: '150px'}}
            variant='contained'
            color="info"
            disabled={createLoad}
            onClick={() => handleCreate()}
              >
                {
                  createLoad ? <CircularProgress size={'24px'}  color='success' /> : 'Gerar relatório'
                }
                
            </Button>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: '24px'
      }}>
        { load ? 
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <CircularProgress size={'24px'} sx={{color: 'black'}} />
          </Box>
         :
          report &&
          <>
            <CustomizedTables
            data={report}
            columns={COLUMNSTABLE}
            moreOptionsTitle={'Baixar relatório'}
            moreOptions={registerButtonComponent}
            />
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              paddingTop: 2
            }}>
              <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
            </Box>
        </>
        }
      </Box>

    </FixedContainer>
  );

}

export default Reports;
